import { Patient } from '../patient/patient';
import { Clinic } from '../clinic/clinic';
import { MCUserData } from '../user/MCUserData';
import { SchedulingType } from '../scheduling-type/scheduling-type';
import { AppointmentType } from '../appointment/appointment-type';

export class Scheduling {
  constructor(
    public id?: number,
    public whenisit?: Date,
    public arrival?: Date,
    public confirmation?: Date,
    public patient?: Patient,
    public clinic?: Clinic,
    public doctor?: MCUserData,
    public schedulingType?: SchedulingType,
    public appointmentType?: AppointmentType
  ) {}
}
